import { Link } from 'react-router-dom';

import SkillData from '../../../types/skillData';
import IconButtonLink from '../../atoms/anchor/IconButtonLink';
import IconButton from '../../atoms/button/IconButton';

import './AdminContent.scss';

interface AdminContentProps {
  skill: SkillData;
  onDelete: (skill: SkillData) => void;
  onTogglePublish: (skill: SkillData) => void;
}

export default function AdminContent({ skill, onDelete, onTogglePublish = () => {} }: AdminContentProps) {
  /*  const Stats = data.map(stat => {
      return (
        <div key={stat.label} className="stat">
          <div className="stat-value">{stat.value}</div>
          {stat.label === 'Unanswered questions' ? (
            <div className="tag stat-label">{stat.label}</div>
          ) : stat.label === 'Current participants' ? (
            <div className="tag stat-label">{stat.label}</div>
          ) : (
            <div className="tag stat-label">{stat.label}</div>
          )}
        </div>
      );
    });*/

  return (
    <div className="admin-content">
      <div className="justify-between items-center">
        <h3 className="skill-heading">
          <Link to={`/skills/${skill.slug}`}>{skill.name}</Link>
        </h3>
        <div className="actions-container">
          <IconButton
            icon={`${skill.isPublished ? 'visibility-outline' : 'visibility-off-outline'}`}
            visualType="no-bg"
            paddingSize="sm"
            onClick={() => onTogglePublish(skill)}
          />
          <IconButtonLink icon="monitoring" to={`/created-skills/statistics/${skill.slug}`} paddingSize="sm" />
          <IconButtonLink icon="edit-outline" to={`/skills/${skill.slug}/edit`} paddingSize="sm" />
          <IconButton icon="delete-outline" visualType="secondary" paddingSize="sm" onClick={() => onDelete(skill)} />
        </div>
      </div>
    </div>
  );
}
